import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8 10.668V5.332m2 3.335-2.001 2-2-2",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.951 1.998a6.002 6.002 0 1 1 0 12.005M5.9 13.635a6.001 6.001 0 0 1-1.806-1.038m0-9.194A5.96 5.96 0 0 1 5.9 2.365M2.045 6.958c.12-.69.361-1.353.712-1.96m-.712 4.043c.12.69.361 1.354.712 1.96",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2
	})]
});
export default SvgDownload;
